/* Rippl site header (idea E, home study v133). Source: theme-build/assets/rh-header.js
   Desktop: hover, focus or tap a word with a menu and the bar extends down into its panel, its rows set
   under the word that opened it, a picture or film on the right answering each row. Escape closes.
   Phone: the burger opens one plain navy index. */
(function () {
  'use strict';
  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (!root || root.__rh) return;
    root.__rh = true;
    var sec = root.closest('.shopify-section') || root.parentNode;
    var bar = root.querySelector('.rh-bar');
    var drop = root.querySelector('.rh-drop');
    var mnav = root.querySelector('.rh-mnav');
    var burger = root.querySelector('.rh-burger');
    var scrim = root.querySelector('.rh-scrim');
    var words = [].slice.call(root.querySelectorAll('.rh-nav .rh-w'));
    var trig = words.filter(function (a) { return a.dataset.k; });
    var panels = {};
    [].slice.call(drop.querySelectorAll('.rh-panel')).forEach(function (p) { panels[p.dataset.k] = p; setupPanel(p); });
    var cur = null, timer = 0, touchOpen = false, h = 64, quiet = false;
    /* the closed menu is inert: it fades out over half a second, and Tab must never walk into it meanwhile (Our Story audit, 11 Oct 2026).
       Account and Cart close an open panel through the bar's focusin below, so Tab goes header, then page, then footer. */
    function inert(on) { if (!(window.Shopify && window.Shopify.designMode)) drop.inert = on; }
    inert(true);

    /* ---- height, sticky offsets for the theme ---- */
    function measure() {
      h = bar.offsetHeight || 64;
      sec.style.setProperty('--rh-h', h + 'px');
      doc.style.setProperty('--header-height', h + 'px');
      doc.style.setProperty('--header-is-sticky', '1');
    }
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(bar);

    /* ---- over a hero: clear, then navy, then white ---- */
    var first = document.querySelector('#main > .shopify-section:first-child');
    var over = root.dataset.over === '1' && first && first.querySelector('[allow-transparent-header]');
    if (over) sec.classList.add('rh-over');
    var footer = null, ticking = false;
    function state() {
      ticking = false;
      footer = footer || document.querySelector('[data-rf]');
      var dark = false, clear = false, deep = false;
      if (over) {
        var fb = first.getBoundingClientRect().bottom;
        if (window.scrollY <= 8) { dark = true; clear = true; }
        else if (fb > h + 2) { dark = true; deep = true; }
      }
      /* a navy section marked data-rh-tone="dark" (Home's Nano, Hotels' route and price-of-plastic band) takes the dark
         bar while it sits under the header, so the light glass never turns grey over navy (Apple audit, 10 Oct 2026) */
      if (!dark) {
        var tn = document.querySelectorAll('[data-rh-tone="dark"]');
        for (var ti = 0; ti < tn.length; ti++) { var tr = tn[ti].getBoundingClientRect(); if (tr.top <= h && tr.bottom > 24) { dark = true; break; } }
      }
      root.classList.toggle('rh-dark', dark);
      root.classList.toggle('rh-clear', clear);
      root.classList.toggle('rh-deep', deep);
      if (footer && footer.offsetParent !== null) {
        var ft = footer.getBoundingClientRect().top;
        root.classList.toggle('rh-fclear', ft <= h && !dark);
      } else root.classList.remove('rh-fclear');
      /* a menu opened from a clear bar shows on navy */
      if (cur && clear) root.classList.add('rh-dark');
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(state); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    state();

    /* ---- the picture beside the rows ---- */
    function setupPanel(p) {
      var pic = p.querySelector('.rh-pic'), ims = pic.querySelectorAll('img'), vid = pic.querySelector('video'), cap = pic.querySelector('figcaption');
      var rows = [].slice.call(p.querySelectorAll('.rh-row')), side = 0;
      function show(r) {
        if (!r) return;
        var src = r.dataset.img, vs = r.dataset.vid, pos = r.dataset.pos || '50% 50%';
        cap.textContent = (r.dataset.cap || '').replace(/\.$/, '');
        pic.classList.toggle('cap', !!cap.textContent);
        if (vs && !reduce.matches) {
          vid.style.objectPosition = pos;
          if (vid.getAttribute('src') !== vs) vid.src = vs;
          if (src) vid.poster = src;
          var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
          vid.classList.add('on');
        } else { vid.classList.remove('on'); if (!vid.paused) vid.pause(); }
        if (!src) return;
        var now = ims[side], next = ims[1 - side];
        if (now.getAttribute('src') === src) { now.classList.add('on'); now.style.objectPosition = pos; return; }
        next.style.objectPosition = pos;
        next.onload = function () { next.classList.add('on'); now.classList.remove('on'); };
        next.src = src;
        if (next.complete && next.naturalWidth) { next.onload = null; next.classList.add('on'); now.classList.remove('on'); }
        side = 1 - side;
      }
      rows.forEach(function (r) {
        r.addEventListener('mouseenter', function () { show(r); });
        r.addEventListener('focus', function () { show(r); });
      });
      p._reset = function () { show(rows[0]); };
      p._warm = function () { rows.forEach(function (r) { if (r.dataset.img && !r._w) { r._w = 1; var i = new Image(); i.decoding = 'async'; i.src = r.dataset.img; } }); };
      p._stop = function () { if (!vid.paused) vid.pause(); };
    }

    /* the first column starts under the word that opened it, pulled back only when it would run off the edge */
    function place(a, p) {
      var r = root.getBoundingClientRect(), pad = r.width * 0.034, x = a.getBoundingClientRect().left - r.left;
      p.style.setProperty('--rh-mx', Math.round(Math.max(pad, Math.min(x, r.width * 0.14))) + 'px');
    }
    function open(k) {
      clearTimeout(timer);
      if (cur === k) return;
      cur = k;
      Object.keys(panels).forEach(function (n) { panels[n].classList.toggle('on', n === k); if (n !== k) panels[n]._stop(); });
      trig.forEach(function (a) { var on = a.dataset.k === k; a.classList.toggle('on', on); a.setAttribute('aria-expanded', String(on)); if (on) place(a, panels[k]); });
      panels[k]._reset();
      root.classList.add('rh-open');
      if (root.classList.contains('rh-clear')) root.classList.add('rh-dark');
      inert(false);
      drop.setAttribute('aria-hidden', 'false');
    }
    function shut() {
      if (!cur) return;
      Object.keys(panels).forEach(function (n) { panels[n]._stop(); });
      cur = null;
      root.classList.remove('rh-open');
      inert(true);
      drop.setAttribute('aria-hidden', 'true');
      trig.forEach(function (a) { a.classList.remove('on'); a.setAttribute('aria-expanded', 'false'); });
      state();
    }
    function close(now) { clearTimeout(timer); if (now) shut(); else timer = setTimeout(shut, 180); }

    /* first picture of each menu, fetched once the page is idle so the first open is never empty */
    var warmFirst = function () { trig.forEach(function (t) { var r = panels[t.dataset.k].querySelector('.rh-row'); if (r && r.dataset.img && !r._w) { r._w = 1; var i = new Image(); i.decoding = 'async'; i.src = r.dataset.img; } }); };
    window.addEventListener('load', function () { setTimeout(function () { (window.requestIdleCallback || setTimeout)(warmFirst); }, 2500); });
    root.querySelector('.rh-nav').addEventListener('pointerenter', function () { trig.forEach(function (a) { panels[a.dataset.k]._warm(); }); }, { once: true });
    words.forEach(function (a) {
      var k = a.dataset.k;
      a.addEventListener('pointerdown', function (e) { touchOpen = e.pointerType !== 'mouse' && !!k && cur !== k; });
      a.addEventListener('mouseenter', function () { if (k) open(k); else close(true); });
      a.addEventListener('mouseleave', function () { if (k) close(); });
      a.addEventListener('focus', function () { if (!k) { close(true); return; } if (quiet) { quiet = false; return; } var kb = true; try { kb = a.matches(':focus-visible'); } catch (x) {} if (kb) open(k); });
      a.addEventListener('click', function (e) {
        if (k && touchOpen) { e.preventDefault(); touchOpen = false; open(k); return; }
        if (k && a.getAttribute('href') === '#') { e.preventDefault(); open(k); }
      });
      a.addEventListener('keydown', function (e) {
        if (!k) return;
        if (e.key === 'ArrowDown' || ((e.key === ' ' || e.key === 'Spacebar'))) {
          e.preventDefault(); open(k);
          var f = panels[k].querySelector('.rh-row'); if (f) f.focus();
        }
      });
    });
    drop.addEventListener('mouseenter', function () { clearTimeout(timer); });
    drop.addEventListener('mouseleave', function () { close(); });
    drop.addEventListener('focusout', function (e) { var t = e.relatedTarget; if (!t || (!drop.contains(t) && trig.indexOf(t) === -1)) close(true); });
    drop.addEventListener('keydown', function (e) {
      if (!cur || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
      var rows = [].slice.call(panels[cur].querySelectorAll('.rh-row')), i = rows.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      if (e.key === 'ArrowUp' && i === 0) { quiet = true; trig.filter(function (a) { return a.dataset.k === cur; })[0].focus(); quiet = false; return; }
      var n = rows[Math.max(0, Math.min(rows.length - 1, i + (e.key === 'ArrowDown' ? 1 : -1)))]; if (n) n.focus();
    });
    scrim.addEventListener('pointerdown', function () { close(true); });
    bar.addEventListener('focusin', function (e) { if (!e.target.dataset || !e.target.dataset.k) close(true); });
    root.addEventListener('focusout', function (e) { if (cur && e.relatedTarget && !root.contains(e.relatedTarget)) close(true); });

    /* ---- phone menu ---- */
    var ml = mnav.querySelector('.rh-ml');
    [].slice.call(ml.children).forEach(function (c, i) { c.style.setProperty('--i', i); });
    var lastFocus = null;
    function mset(on) {
      root.classList.toggle('rh-mopen', on);
      doc.style.overflow = on ? 'hidden' : '';
      doc.classList.toggle('rh-lock', on);
      burger.setAttribute('aria-expanded', String(on));
      burger.setAttribute('aria-label', on ? 'Close menu' : 'Menu');
      mnav.setAttribute('aria-hidden', String(!on));
      if (on) { close(true); ml.scrollTop = 0; lastFocus = document.activeElement; var f = ml.querySelector('a'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60); }
      else if (lastFocus === burger || root.contains(document.activeElement)) burger.focus({ preventScroll: true });
    }
    burger.addEventListener('click', function () { mset(!root.classList.contains('rh-mopen')); });
    mnav.addEventListener('click', function (e) { if (e.target.closest('a')) mset(false); });
    /* keep Tab inside the open phone menu and its close button */
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !root.classList.contains('rh-mopen')) return;
      var f = [burger].concat([].slice.call(ml.querySelectorAll('a'))), i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (root.classList.contains('rh-mopen')) { mset(false); burger.focus(); return; }
      if (cur) { var a = trig.filter(function (t) { return t.dataset.k === cur; })[0]; var inside = root.contains(document.activeElement); close(true); if (a && inside) { quiet = true; a.focus(); quiet = false; } }
    });
    window.addEventListener('resize', function () {
      var wide = getComputedStyle(burger).display === 'none';
      if (wide && root.classList.contains('rh-mopen')) mset(false);
      if (!wide && cur) close(true);
    });
    document.addEventListener('pointerdown', function (e) { if (cur && !root.contains(e.target)) close(true); });

    /* ---- cart count: show the badge only when there is something in the cart ---- */
    var cartA = root.querySelector('.rh-cart'), cc = cartA && cartA.querySelector('cart-count');
    function syncCount() { if (!cc) return; var n = parseInt(cc.textContent, 10) || 0; cartA.classList.toggle('rh-has', n > 0); }
    if (cc && 'MutationObserver' in window) new MutationObserver(syncCount).observe(cc, { childList: true, characterData: true, subtree: true });
    document.addEventListener('cart:change', function (e) { if (e.detail && e.detail.cart && cartA) cartA.classList.toggle('rh-has', e.detail.cart.item_count > 0); });
    syncCount();

    /* ---- the cart drawer takes focus when it opens and gives it back when it closes (Apple audit round 2, A6) ---- */
    var drawer = document.getElementById('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      var backTo = null;
      new MutationObserver(function () {
        if (drawer.hasAttribute('open')) {
          if (backTo) return;
          var a = document.activeElement;
          backTo = (a && a !== document.body && !drawer.contains(a)) ? a : cartA;
          setTimeout(function () {
            if (!drawer.hasAttribute('open')) return;
            var sr = drawer.shadowRoot, inside = drawer.contains(document.activeElement) || (sr && sr.activeElement);
            if (inside) return;
            var c = (sr && sr.querySelector('[part~="close-button"]')) || drawer.querySelector('button,a[href]');
            if (c) c.focus({ preventScroll: true });
          }, 60);
        } else if (backTo) {
          var b = backTo; backTo = null;
          var now = document.activeElement;
          if ((!now || now === document.body || drawer.contains(now)) && b.isConnected) b.focus({ preventScroll: true });
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }

    /* ---- theme editor: open the menu that holds the selected row ---- */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        if (!root.contains(e.target)) return;
        var p = e.target.closest('.rh-panel'), k = p ? p.dataset.k : e.target.dataset.k;
        if (k && getComputedStyle(burger).display === 'none') open(k);
      });
      document.addEventListener('shopify:block:deselect', function (e) { if (root.contains(e.target)) close(true); });
    }
    root._rhClose = function () { close(true); mset(false); };
  }

  function boot() { [].slice.call(document.querySelectorAll('[data-rh]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
